import React from 'react';
import classnames from 'classnames';
export default function AppointmentPicker({ activeSlot, appointmentSlots, onSelect, }) {
    return (React.createElement("div", { className: "overflow-x-auto mt-2" },
        React.createElement("div", { className: "-mx-2 sm:mx-0 flex sm:grid sm:grid-cols-7 sm:gap-x-2" }, appointmentSlots.map((appointmentSlot, i) => (React.createElement("div", { key: i, className: "px-2 sm:px-0" },
            React.createElement("label", { className: "form-label mb-2 w-28" }, appointmentSlot.label),
            React.createElement("div", { className: "space-y-2" }, (appointmentSlot.slots || []).map((slot) => {
                var _a;
                const selected = activeSlot &&
                    (activeSlot._id === slot._id ||
                        ((_a = activeSlot.windowStart) === null || _a === void 0 ? void 0 : _a.format()) ===
                            slot.windowStart.format());
                return (React.createElement(AppointmentSlot, { selected: selected, appointmentSlot: slot, key: slot._id, onSelect: onSelect }));
            }))))))));
}
function AppointmentSlot({ appointmentSlot, selected, onSelect }) {
    const { label, disabled } = appointmentSlot;
    function handleSelect() {
        onSelect(appointmentSlot);
    }
    const className = classnames('button block', {
        'button-hollow-green': !selected,
        'button-green': selected,
        'w-32': true,
    });
    return (React.createElement("button", { className: className, onClick: handleSelect, disabled: disabled }, label));
}
